import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { TranslateProvider, TranslateScope } from '@pegasus/translation';
import { CommercialMessagesProvider } from '@pegasus/commercial-messages';
import { ErrorBoundary } from '@browsing/components';
import { ConfigProvider, configShape } from '@browsing/config';

import LoadableGenericErrorMessage from '@client/components/shared/genericErrorMessage';

import { LUXProviderWrapper } from './lux-provider-wrapper';

import '@client/styles/core.scss';

/* eslint-disable react/prop-types */
export default function AppRoot({ store, routes, translations, config }) {
    return (
        <ConfigProvider config={config}>
            <TranslateProvider translations={translations}>
                <TranslateScope>
                    <Provider store={store}>
                        <LUXProviderWrapper>
                            <ErrorBoundary
                                fallbackUI={LoadableGenericErrorMessage}
                                componentName="AppRoot"
                            >
                                <CommercialMessagesProvider localeCode={config.localeCode}>
                                    <Router>{routes}</Router>
                                </CommercialMessagesProvider>
                            </ErrorBoundary>
                        </LUXProviderWrapper>
                    </Provider>
                </TranslateScope>
            </TranslateProvider>
        </ConfigProvider>
    );
}

AppRoot.propTypes = {
    store: PropTypes.object.isRequired,
    routes: PropTypes.object.isRequired,
    translations: PropTypes.object.isRequired,
    config: configShape.isRequired,
};
